import React from 'react';

function SystemPromptEditor({ sections, setSections, handleSavePrompt, loading }) {
  const PROMPT_SECTIONS = [
    { key: 'personality', label: 'Personality', placeholder: 'Describe the AI personality...' },
    { key: 'tone', label: 'Tone', placeholder: 'Describe the tone of responses...' },
    { key: 'rules', label: 'Rules', placeholder: 'List rules for the AI...' },
    { key: 'knowledge', label: 'Knowledge', placeholder: 'Add any extra knowledge or context...' },
    { key: 'faq', label: 'FAQ', placeholder: 'Add common Q&A or info...' }
  ];

  return (
    <div className="prompt-editor">
      <h2>System Prompt</h2>
      {PROMPT_SECTIONS.map(section => (
        <div key={section.key} style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 600, color: '#667eea', display: 'block', marginBottom: 6 }}>{section.label}</label>
          <textarea
            value={sections[section.key] || ''}
            onChange={e => setSections(s => ({ ...s, [section.key]: e.target.value }))}
            rows={
              section.key === 'personality' || section.key === 'tone' ? 6 :
              section.key === 'rules' ? 12 :
              section.key === 'knowledge' || section.key === 'faq' ? 20 : 4
            }
            placeholder={section.placeholder}
            className="prompt-textarea"
          />
        </div>
      ))}
      <div className="prompt-actions">
        <button className="save-btn" onClick={handleSavePrompt} disabled={loading}>
          {loading ? 'Saving...' : 'Save Prompt'}
        </button>
      </div>
    </div>
  );
}

export default SystemPromptEditor; 